<template>
  <ul class="pricing-tariffs-list pricing-tariffs-list--odd">
    <template v-for="tariff in tariffs">
      <li class="pricing-tariffs-list__item">
        <PricingTariffsCard :currency="currency" :lang="lang" :tariff="tariff"></PricingTariffsCard>
      </li>
    </template>
  </ul>
</template>

<script>
import translations from './pricing-translations';
import PricingTariffsCard from './PricingTariffsCard.vue';

export default {
  name: 'PricingTariffsList',
  components: { PricingTariffsCard },
  props: {
    currency: {
      type: String,
      required: true,
    },
    lang: {
      type: String,
      default: 'ru',
    },
  },
  computed: {
    translations() {
      return translations[this.lang];
    },
    tariffs() {
      return Object.keys(this.translations['tariffs']);
    },
  },
};
</script>
